import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveUserType, saveUserTypePublic } from './index';

// Api's
import { userTypeApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getUserTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      userTypeApi.getDomain
    );
    if (response.data.result) {
      yield put(saveUserType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUserType(null, true, resultError.messagesDataError));
    }
  }
}

export function* getUserTypePublicSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      userTypeApi.getDomainPublic
    );
    if (response.data.result) {
      yield put(saveUserTypePublic(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUserTypePublic(null, true, resultError.messagesDataError));
    }
  }
}
